import { render, staticRenderFns } from "./InitialSetupPage.vue?vue&type=template&id=4e75c4ec&lang=pug"
import script from "./InitialSetupPage.vue?vue&type=script&lang=js"
export * from "./InitialSetupPage.vue?vue&type=script&lang=js"
import style0 from "./InitialSetupPage.vue?vue&type=style&index=0&id=4e75c4ec&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e75c4ec')) {
      api.createRecord('4e75c4ec', component.options)
    } else {
      api.reload('4e75c4ec', component.options)
    }
    module.hot.accept("./InitialSetupPage.vue?vue&type=template&id=4e75c4ec&lang=pug", function () {
      api.rerender('4e75c4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/initial_setup/InitialSetupPage.vue"
export default component.exports